import type { FaireProductEntity } from "../../entity_types/product";

export const p_b57ayww6fk: FaireProductEntity = {
  token: "p_b57ayww6fk",
  type: "product",
  name: "PUREOLOGY Find Your Strength Hair Repair 3 Piece Kit",
  brandToken: "b_350t9wyo",
  brandName: "Best Beauty Group",
  imageUrl:
    "https://cdn.faire.com/fastly/d26786fe3a02dae662ea1e354868c68c496dbd069db7a72b8ae959b82055beb6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7264301d03f41840701b354f0d3b46179b7de107c1ed4fc48d4db5438ff910b.png",
    "https://cdn.faire.com/fastly/c9a9b09ffe1c4a9432440973f08dde5e4798d13c6f73267545ec11bb2993cec7.jpeg",
    "https://cdn.faire.com/fastly/7da2348874dd14c2d99c53dcf7c561f7a0cc0c6ee0baef5978ca4c34fb3dde6b.webp",
    "https://cdn.faire.com/fastly/802827ea19666eb65d62a01e6436f62c6aeaad0f9bfc900df105e5dfcdb9329d.jpeg",
    "https://cdn.faire.com/fastly/efe8f1c628d7d0a541d0fe761cd48e477004003b5c802b70da944b1e938843c7.jpeg",
    "https://cdn.faire.com/fastly/c32f50793a0b7229166d07c0eb7a36178a352bbb60045bc9b45cb0ce6de38fba.webp",
  ],
  priceDollars: 2.5,
  description:
    "Size: Shampoo, Conditioner, Treatment Sachet \n\nPerfect for brittle, color-treated hair prone to breakage, this strengthening shampoo and conditioner provides a fortifying cleanse and intense repair. For an extra boost of restoration, the concentrated mask treatment infuses hair with antioxidants and protein to mend damage and prevent future split ends. Achieve a smooth, resilient, and high-shine finish with this essential strengthening system.\n\n\nIngredients & Fragrances\n\nShampoo & Conditioner:\nThe plant-based protein Keravis strengthens strands and prevents damage while the powerful antioxidant Astaxanthin helps heal and repair. With a scent as bright as a California fruit farm, breathe in sweet Raspberry and Peach blended with fresh Water Flowers.\n\nTreatment:\nLike a vitamin shot for your hair, antioxidant-rich Olive Oil containing fatty acids helps promote healthy shine and softness, while Goji Berries protect from free radicals and use a high concentration of amino acids and proteins to add additional shine. A fresh, floral scent of Peony and Jasmine is slightly sweetened with a citrusy touch of Mandarin.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:04.594Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
